<template >
  <Transition name="fade">
    <div class="pfpopup" :class="{'pfpopup_alt':alt}"  @pointerdown="close" v-show="modelValue" @click.stop>
      <div class="pfpopup__content" :class="{'pfpopup__content_centered':centered}" ref="content" @pointerdown.stop>
        <CloseBtn v-if="closable" class="pfpopup__close" @click="close" :alt="alt" />
        <slot />
      </div>
    </div>
  </Transition>
</template>
<script>
import CloseBtn from './CloseBtn.vue'

export default {
  components: {
    CloseBtn
  },
  props: {
    modelValue: {type: Boolean},
    alt: {type: Boolean, default: false},
    centered: {type: Boolean, default: false},
    closable: {type: Boolean, default: true}
  },
  methods: {
    checkOverflow(){
      if (this.$refs.content.scrollHeight > window.innerHeight - 40)
        this.$el.classList.add('popup_overflow')
      else
        this.$el.classList.remove('popup_overflow')
    },
    close(){
      this.$emit('update:modelValue', false)
    }
  },
  mounted(){
    this.checkOverflow()
    window.addEventListener('resize', this.checkOverflow, { passive: true })
  },
  updated(){
    this.checkOverflow()
  },
}
</script>

<style lang="sass">
.pfpopup
  position: fixed
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  overflow-y: auto
  left: 0
  right: 0
  top: 0
  bottom: 0
  z-index: 1000000000
  background: rgba(20, 23, 54, 0.1)
  
  & &__title
    margin: 20px 0 20px !important
    font-weight: bold
    font-size: 28px
    line-height: 34px
    color: colors.$bluefont
    @include for-mob
      margin-bottom: 10px !important
  & &__text
    color: colors.$gray7
    font-size: 16px
    line-height: 26px    
    padding-bottom: 30px
    white-space: pre-wrap
    @include for-mob
      padding-bottom: 20px
  & &__btn
    margin: 40px auto 0
  & &__content
    box-sizing: border-box
    width: 684px
    max-width: calc(100% - 20px)
    position: relative
    background: colors.$mainbg
    z-index: 1
    box-shadow: 0px 20px 40px rgba(34, 64, 92, 0.1)
    padding: 45px 40px
    @include for-mob
      padding: 25px 20px
    &_centered
      min-height: 282px
      padding: 0
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      text-align: center
      >*
        margin: 0
      .popup__text
        max-width: 500px
      .popup__text:last-child
        padding-bottom: 0
  & &__close
    position: absolute
    top: 20px
    right: 40px
    @include for-mob
      right: 20px
  &_alt
    background: transparentize(#343540, .75)
    & .pfpopup__content
      overflow: hidden
      border-radius: 8px
      padding: 16px 32px 32px
      width: 520px
      box-shadow: none
    & .pfpopup__close
      position: static
      margin: 0 0 16px
      margin-left: auto
</style>